'use strict';

class UsersActivePageController {
  constructor($scope,
              $q,
              $filter,
              DashboardDataProvider) {
    const $t = $filter('translate');
    const currentDateFormat = $t('dash.panel.currentDateFormat');
    var initial = true;

    angular.extend($scope, {
      getData: getData
    });

    function getData(startDate, endDate) {
      return DashboardDataProvider.getUsers(startDate, endDate)
        .then((reportInfo) => {
          let dailyActiveUsers;
          let dailyInactiveUsers;
          let monthlyActiveUsers;

          if (!reportInfo || !reportInfo.executions || reportInfo.executions.length <= 0) {
            dailyActiveUsers = [];
            dailyInactiveUsers = [];
            monthlyActiveUsers = [];
          } else {
            let executions = reportInfo.executions
              .slice()
              .sort((a, b) => a.executionDateMs - b.executionDateMs); // latest last

            dailyActiveUsers = executions
              .map(execution => ({
                x: execution.executionDateMs,
                y: execution.data?.find(d => d.id === 3)?.value
              }));

            dailyInactiveUsers = executions
              .map(execution => ({
                x: execution.executionDateMs,
                y: execution.data?.find(d => d.id === 1)?.value - execution.data?.find(d => d.id === 3)?.value
              }));

            monthlyActiveUsers = executions
              .map(execution => ({
                x: execution.executionDateMs,
                y: execution.data?.find(d => d.id === 4)?.value
              }));

            if (initial) {
              getLastMeasurement(executions[executions.length - 1]);
              initial = false;
            }
          }

          return [
            {
              data: dailyActiveUsers,
              label: $t('dash.panel.reports.monthlyActiveUsers.dailyActiveUsers'),
              color: 'blue'
            },
            {
              data: dailyInactiveUsers,
              label: $t('dash.panel.reports.monthlyActiveUsers.dailyInactiveUsers'),
              color: 'gray'
            },
            {
              data: monthlyActiveUsers,
              label: $t('dash.panel.reports.monthlyActiveUsers.monthlyActiveUsers'),
              type: 'line'
            }
          ];
        });
    }

    // Get last measurement from initial call
    function getLastMeasurement(executions) {
      if (!executions) {
        return;
      }

      let info = [];
      const dictionaryHelper = [
        {
          id: 1,
          name: $t('dash.panel.reports.monthlyActiveUsers.totalUsers'),
          icon: 'user-friends'
        },
        // {
        //   id: 2,
        //   name: 'New Users',
        //   icon: 'user'
        // },
        {
          id: 3,
          name: $t('dash.panel.reports.monthlyActiveUsers.dailyActiveUsers'),
          icon: 'chart-line'
        },
        {
          id: 4,
          name: $t('dash.panel.reports.monthlyActiveUsers.monthlyActiveUsers'),
          icon: 'chart-line'
        }
      ];

      info.push({
        icon: 'clock',
        name: $t('dash.panel.reports.lastMeasured'),
        value: $filter('date')(executions.executionDateMs, currentDateFormat)
      });

      for (let [key, value] of Object.entries(executions.data || {})) {
        let helper = dictionaryHelper.find(el => el.id === value.id);
        if (helper) {
          info.push({
            icon: helper.icon || 'chart-line',
            name: helper.name + ' -',
            value: value.value
          });
        }
      }
      $scope.lastMeasurement = info;
    }
  }
}

export default angular
  .module('main.dashboard.usersActivePage.controller', [])
  .controller('UsersActivePageController', UsersActivePageController)
  .name;
